<template>
    <div class="grid grid--row">
        <slot></slot>
    </div>
</template>
<style lang="scss"></style>
